import styled from 'styled-components';
import { Button } from '../../../components/Button';
import { Input } from '../../../components/Input';
import { useState } from 'react';
import { Message } from './EnterCode';

type EnterEmailProps = {
  setEmail: (email: string) => void;
  email: string;
  isActive: boolean;
  onClick: () => void;
};

export const EnterEmail = ({ email, setEmail, onClick, isActive }: EnterEmailProps) => {
  const [invalidEmail, setInvalidEmail] = useState(false);
  const isValidEmail = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const onNextPress = () => {
    if (isValidEmail()) {
      onClick();
    } else {
      setInvalidEmail(true);
    }
  };
  return (
    <Container>
      <StyledInput
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Enter your email address"
      />
      {invalidEmail && <Message>Please enter a valid email</Message>}
      <ButtonWrapper>
        <Button onClick={onNextPress} disabled={!isActive}>
          Next
        </Button>
      </ButtonWrapper>
    </Container>
  );
};

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
`;

const Title = styled.h3`
  margin: 0;
  text-align: center;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  max-width: 350px;
`;

const StyledInput = styled(Input)`
  width: 100%;
  min-width: 350px;

  @media (max-width: 768px) {
    min-width: unset;
  }
`;
